// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3svAx","content":"styles_content__1Fn4w"};